/**
 * MonsterEditorTestPage - Auth-free harness for Playwright screenshots of MonsterEditor.
 * date_of_change: 2026-04-27 - Created for visual verification of the dark-brown + crimson theme.
 *
 * Renders the real MonsterEditor component at templateId='new', which creates a blank
 * editor with no backend calls. The Playwright spec then populates fields via browser
 * automation to capture the themed form in a realistic state.
 *
 * Security: Only reachable when REACT_APP_ENABLE_TEST_ROUTES=true (build-time flag).
 *           Never shipped in production bundles.
 */
import React from 'react';
import MonsterEditor from '../components/MonsterEditor';

const MonsterEditorTestPage = () => {
  return <MonsterEditor />;
};

export default MonsterEditorTestPage;
